import React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";
import {Country} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";

interface IProps {
    offer: IOffer;
    country: Country;
}

export const OfferGeneratedDescriptionTextHouses = (props: IProps) => {
    const {offer, country} = props;

    const futureEndDate = offer.construction_date_range?.upper && isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = offer.construction_date_range?.lower && isFuture(parseISO(offer.construction_date_range.lower));
    const upper = props.offer.construction_date_range?.upper && formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);

    const propertiesPlural = pluralize(["nowego", "nowych", "nowych"]);
    const housePlural = pluralize(["domu", "domy", "domów"]);
    const houseCountPlural = pluralize(["domu", "domów", "domów"]);
    const propertiesNewPlural = pluralize(["nowy", "nowe", "nowych"]);
    const arePlural = pluralize(["jest", "są", "jest"]);

    const allProperties =
        offer.properties ??
        Object.values(offer.stats?.all_house_types).reduce((acc, curr) => {
            return acc + curr;
        }, 0);

    return (
        <>
            <p>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper ? `z planowanym na ${upper} roku terminem oddania do użytkowania` : ""
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper ? `w ${upper} roku` : ""}.`}
            </p>

            {(offer.properties || offer.stats?.all_house_types) && (
                <p>Cały projekt składa się z {` ${allProperties} ${propertiesPlural(allProperties)} ${houseCountPlural(allProperties)}`}.</p>
            )}

            <p>
                {offer.stats?.properties_count_for_sale ? (
                    `Aktualnie w inwestycji ${offer.name} w sprzedaży ${arePlural(offer.stats.properties_count_for_sale)} ${
                        offer.stats.properties_count_for_sale
                    } ${propertiesNewPlural(offer.stats.properties_count_for_sale)} ${housePlural(offer.stats.properties_count_for_sale)} ${
                        !!offer.stats.ranges_area_min
                            ? ` o powierzchni ${
                                  offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                      ? ` ${offer.stats.ranges_area_min}`
                                      : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                              } metrów kwadratowych`
                            : ""
                    }${
                        offer.stats.ranges_price_min
                            ? `, w cenie od ${numberFormat(offer.stats.ranges_price_min)} ${country === Country.POLAND ? "zł" : "eur"}`
                            : ""
                    }.`
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych domów w sprzedaży.</>
                )}
            </p>
        </>
    );
};
import React from "react";
import {isFuture, parseISO} from "date-fns";

import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";
import {Country} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";

interface IProps {
    offer: IOffer;
    country: Country;
}

export const OfferGeneratedDescriptionTextHouses = (props: IProps) => {
    const {offer, country} = props;

    const futureEndDate = offer.construction_date_range?.upper && isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = offer.construction_date_range?.lower && isFuture(parseISO(offer.construction_date_range.lower));
    const upper = props.offer.construction_date_range?.upper && formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);

    const propertiesPlural = pluralize(["nowego", "nowych", "nowych"]);
    const housePlural = pluralize(["domu", "domy", "domów"]);
    const houseCountPlural = pluralize(["domu", "domów", "domów"]);
    const propertiesNewPlural = pluralize(["nowy", "nowe", "nowych"]);
    const arePlural = pluralize(["jest", "są", "jest"]);

    const allProperties =
        offer.properties ??
        Object.values(offer.stats?.all_house_types).reduce((acc, curr) => {
            return acc + curr;
        }, 0);

    return (
        <>
            <p>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper ? `z planowanym na ${upper} roku terminem oddania do użytkowania` : ""
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper ? `w ${upper} roku` : ""}.`}
            </p>

            {(offer.properties || offer.stats?.all_house_types) && (
                <p>Cały projekt składa się z {` ${allProperties} ${propertiesPlural(allProperties)} ${houseCountPlural(allProperties)}`}.</p>
            )}

            <p>
                {offer.stats?.properties_count_for_sale ? (
                    `Aktualnie w inwestycji ${offer.name} w sprzedaży ${arePlural(offer.stats.properties_count_for_sale)} ${
                        offer.stats.properties_count_for_sale
                    } ${propertiesNewPlural(offer.stats.properties_count_for_sale)} ${housePlural(offer.stats.properties_count_for_sale)} ${
                        !!offer.stats.ranges_area_min
                            ? ` o powierzchni ${
                                  offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                      ? ` ${offer.stats.ranges_area_min}`
                                      : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                              } metrów kwadratowych`
                            : ""
                    }${
                        offer.stats.ranges_price_min
                            ? `, w cenie od ${numberFormat(offer.stats.ranges_price_min)} ${country === Country.POLAND ? "zł" : "eur"}`
                            : ""
                    }.`
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych domów w sprzedaży.</>
                )}
            </p>
        </>
    );
};
